import {Pipe, PipeTransform} from '@angular/core';
import {ActivityTypesEnum} from '../../interfaces/ActivityTypesEnum';
import {BadgeColorsEnum} from '../../interfaces/BadgeColorsEnum';
import {ITransaction} from '../../interfaces/transaction.interface';

@Pipe({
  name: 'transactionBadge',
})
export class TransactionBadgePipe implements PipeTransform {

  transform(transaction: ITransaction): { label: string, color: BadgeColorsEnum } {
    switch (transaction?.activityType ??(<any>transaction)?.lastActivityActivityType) {
      case ActivityTypesEnum.Dispensed:
        return {label: 'Dispensed', color: BadgeColorsEnum.Red};
      case ActivityTypesEnum.LostStolen:
        return {label: 'Lost/Stolen', color: BadgeColorsEnum.Yellow};
      case ActivityTypesEnum.Received:
      case ActivityTypesEnum.Compounded:
        return {label: 'Received', color: BadgeColorsEnum.Green};
      case ActivityTypesEnum.Amendment:
        return {label: 'Amended', color: BadgeColorsEnum.Blue};
      case ActivityTypesEnum.DamagedExpired:
        return {label: 'Damaged/Expired', color: BadgeColorsEnum.Yellow};
      case ActivityTypesEnum.ReturnedToWholesaler:
      case ActivityTypesEnum.Returned:
        return {label: 'Returned', color: BadgeColorsEnum.Red};
      case ActivityTypesEnum.Audit:
        return {label: 'Audit', color: BadgeColorsEnum.Purple};
      case ActivityTypesEnum.MovedFrom:
        return {label: 'Moved From', color: BadgeColorsEnum.Pink};
      case ActivityTypesEnum.MovedTo:
        return {label: 'Moved To', color: BadgeColorsEnum.Pink};
      case ActivityTypesEnum.SoldToProvider:
        case ActivityTypesEnum.Sold:
        return {label: 'Sold Prov', color: BadgeColorsEnum.Red};
      case ActivityTypesEnum.SoldToReverseDistributor:
        return {label: 'Sold Rev Dist', color: BadgeColorsEnum.Red};
      case ActivityTypesEnum.WastedDestroyed:
        return {label: 'Wasted/Destroyed', color: BadgeColorsEnum.Red};
      case ActivityTypesEnum.Created:
        return {label: 'Created', color: BadgeColorsEnum.Default};
      case ActivityTypesEnum.Mixed:
        return {label: 'Mixed', color: BadgeColorsEnum.Red};
      default:
        return {label: '', color: BadgeColorsEnum.Default};
    }
  }

}
